
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { UtilsService } from "app/services/utils.service";
import { UserResource } from "app/resources/user/user-resource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class HeaderService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getUserProfile(email: string): Observable<UserResource> {
    return this.http.get<UserResource>(environment['url'] + '/admin/user/getProfile?userName=' + atob(email));
  }

  private UserResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }
}
